import React, {Component} from 'react'
import {InstantSearch} from 'react-instantsearch-dom'
import algoliasearch from 'algoliasearch/lite'
import CustomSearchBar from './index'
import DropDownResults from './dropdown-results'
import {API_KEY, APP_ID, getShopifyAlgoliaIndex} from '../../config'

export default class AlgoliaSearchBar extends Component {
    constructor(props) {
        super(props)

        this.state = {
            value: null,
            results: [],
        }

        this.index = getShopifyAlgoliaIndex(this.props.algoliaIndex)
        this.accordionTrigger = this.accordionTrigger.bind(this)

        // ============
        // Algolia Variable
        // only init when the component has mounted.
        // Putting in a Conditional Request to prevent a large number of Algolia <empty searches>
        // Resource: https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/react/#implementing-a-proxy
        // ============
        const algoliaClient = algoliasearch(APP_ID, API_KEY)
        let self = this
        this.searchClient = {
            search(requests) {
                if (requests.every(({params}) => !params.query)) {
                    return Promise.resolve({
                        results: requests.map(() => ({
                            hits: [],
                            nbHits: 0,
                            nbPages: 0,
                            page: 0,
                            processingTimeMS: 0
                        }))
                    })
                }
                let response = algoliaClient.search(requests)
                response.then((data) => {
                    self.setState({results: data.results})
                })
                return Promise.resolve({results: self.state.results})
            }
        }
    }

    accordionTrigger(ID) {
        document.querySelector(`#${ID}`).classList.remove(`visible`)
        // this.setState({
        //     searchValue: ``,
        //     value: null
        // })
    }

    render() {
        return (
            <React.Fragment>
                <InstantSearch indexName={this.index.products} searchClient={this.searchClient}>
                    <CustomSearchBar
                        onChange={value => this.setState({value: value})}
                        delay={400}
                        results={this.state.results}
                    />
                    <div
                        className={`algolia-search-results padding-2x background-white ${
                            this.state.value ? `` : `hide`
                        }`}
                    >
                        <DropDownResults index={this.index}/>
                    </div>
                </InstantSearch>
                <div className="search-close">
                    <a
                        className="button is-border is-medium"
                        data-close-accordion="#SearchContainer"
                        onClick={() => this.accordionTrigger(`SearchContainer`)}
                    >
                        Close
                    </a>
                </div>
            </React.Fragment>
        )
    }
}
